import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent } from '@angular/common/http';

import { MsalService } from '@azure/msal-angular';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { UserDirectoryRequestDTO, UserDirectoryResponseDTO } from '../dtos';
import { BaseService } from './base.service';
import { GlobalsService } from './globals.service';
import { isAssigned, replaceEmailExt, toISODateString } from '../utils';

@Injectable()
export class UserDirectoryService extends BaseService {
    private _userDirectoryUrl: string;

    constructor(private readonly _http: HttpClient, globalsSrv: GlobalsService, authSrv: MsalService) {
        super(globalsSrv, authSrv);

        this._userDirectoryUrl = `${this.apiUrl}/UserDirectory`;
    }

    private requestToAny(request: UserDirectoryRequestDTO): any {
        const obj: any = { ...request };

        if (isAssigned(request.userLastUpdatedFromDt)) obj.userLastUpdatedFromDt = toISODateString(request.userLastUpdatedFromDt);
        if (isAssigned(request.userLastUpdatedToDt)) obj.userLastUpdatedToDt = toISODateString(request.userLastUpdatedToDt);

        if (isAssigned(request.userRoleExpireFromDt)) obj.userRoleExpireFromDt = toISODateString(request.userRoleExpireFromDt);
        if (isAssigned(request.userRoleExpireToDt)) obj.userRoleExpireToDt = toISODateString(request.userRoleExpireToDt);

        if (isAssigned(request.userAccountActivatedFromDt)) obj.userAccountActivatedFromDt = toISODateString(request.userAccountActivatedFromDt);
        if (isAssigned(request.userAccountActivatedToDt)) obj.userAccountActivatedToDt = toISODateString(request.userAccountActivatedToDt);

        if (isAssigned(request.requestFromDt)) obj.requestFromDt = toISODateString(request.requestFromDt);
        if (isAssigned(request.requestToDt)) obj.requestToDt = toISODateString(request.requestToDt);

        obj.userEmail = replaceEmailExt(request.userEmail);
        obj.userFullName = replaceEmailExt(request.userFullName);
        obj.userStatus = replaceEmailExt(request.userStatus);
        obj.userRoleNames = replaceEmailExt(request.userRoleNames);
        obj.userContextNames = replaceEmailExt(request.userContextNames);
        obj.userActiveProfileNames = replaceEmailExt(request.userActiveProfileNames);
        obj.userPendingProfileNames = replaceEmailExt(request.userPendingProfileNames);
        obj.userIdbApps = replaceEmailExt(request.userIdbApps);
        obj.userScope = replaceEmailExt(request.userScope);
        obj.filterText = replaceEmailExt(request.filterText);

        return obj;
    }

    readUsers(request: UserDirectoryRequestDTO): Observable<UserDirectoryResponseDTO> {
        const obj = this.requestToAny(request);

        const options = {
            params: this.getHttpParams(obj),
            headers: this.getHttpHeaders(),
        };

        return this._http.get<UserDirectoryResponseDTO>(this._userDirectoryUrl, options).pipe(catchError(this.onHttpError));
    }

    exportUsers(format: string, request: UserDirectoryRequestDTO): Observable<HttpEvent<Blob>> {
        const obj = this.requestToAny(request);

        const params = this.getHttpParams(obj);
        const headers = this.getHttpHeaders();

        return this._http
            .get(`${this._userDirectoryUrl}/export/${format}`, {
                params: params,
                reportProgress: true,
                observe: 'events',
                responseType: 'blob',
                headers: headers,
            })
            .pipe(catchError(this.onHttpError));
    }
}
